<div
  cdkTrapFocus
  id="modal-dialog"
  class="modal-dialog"
  *ngIf="isOpen"
  #modalDialog
>
  <div>
    <div shadowScroll>
      <header id="modal-dialog-header" class="modal-dialog-header">
        <h1 class="h3">{{ headerTitle }}</h1>
        <nibtravel-icon
          tabindex="0"
          size="lg"
          icon="close"
          (click)="close()"
        ></nibtravel-icon>
      </header>
      <div id="modal-dialog-body" class="modal-dialog-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <footer id="modal-dialog-footer" class="modal-dialog-footer">
    <nibtravel-button
      *ngIf="!customFooter"
      [text]="closeButtonText"
      [type]="'secondary'"
      (btnClick)="close()"
      class="action"
    >
    </nibtravel-button>
    <ng-content select="[footer]"></ng-content>
  </footer>
</div>
